/**
 * Bill Model
 *
 *
 *
 *
 */
import React, { useState, useEffect, useContext } from 'react';

import Model from './models';

import { Tag, Card, Typography, Button } from 'antd';

import { ApiUtils, BaseAPI } from 'soxo-bootstrap-core';
// import { Referrers } from '.';

// import BillDetailView from './../modules/common/components/bill-detail/bill-detail';

// import BillDetail from './../modules/common/components/bill-detail/bill-detail';

const { Text } = Typography;

const moment = require('moment-timezone');

class Customer extends BaseAPI {
    constructor() {
        super();

        this.fields = [
            {
                field: 'opb_name',
                caption: 'Name',
            },
            {
                field: 'opb_opno',
                caption: 'num',
            },
            // {
            //     field: 'cold_tm',
            //     caption: 'Date'
            // },
            // {
            //     field: 'Collected By',
            //     caption: 'cold_user'
            // }
        ];

        // this.columns = ;
    }

    get id() {
        return 'customer_id';
    }

    get getEndpoint() {
        return 'customer';
    }

    get path() {
        return `customer`;
    }

    get getName() {
        return this.modelName;
    }

    get modelName() {
        return `customer`;
    }

    disableAdd = () => {
        return true;
    };

    getCorporate = () => {
        return ApiUtils.get({
            url: `customer?page=1&limit=10`,
        });
    };

    getCustomer = () => {
        return ApiUtils.get({
            url: `customer`,
        });
    };

    get columns() {
        return [
            {
                field: 'opb_name',
                render: record => {
                    return record.opb_name;
                },
                caption: 'Name',
            },
            {
                field: 'opb_gender',
                render: record => {
                    return <Tag color={record.opb_gender === 'Male' ? 'green' : 'orange'}>{record.opb_gender}</Tag>;
                },
                caption: 'Gender',
            },
            {
                field: 'opb_age',
                render: record => {
                    return record.opb_age;
                },
                caption: 'Age',
            },
            {
                field: 'opb_mobile',
                render: record => {
                    return record.opb_mobile;
                },
                caption: 'Mobile',
            },
            {
                field: 'opb_opno',
                render: record => {
                    return record.opb_opno;
                },
                caption: 'OP No.',
            },
            {
                // field: 'cold_amt',
                render: record => {
                    return record.opb_amt;
                },
                caption: 'Amount',
            },

            {
                // field: 'cold_amt',
                render: record => {
                    return record.opb_bdisamt;
                },
                caption: 'Discount',
            },

            {
                // field: 'cold_amt',
                render: record => {
                    return record.opb_netamt;
                },
                caption: 'Net Amount',
            },

            {
                // field: 'cold_amt',
                render: record => {
                    return record.opb_paidamt;
                },
                caption: 'Paid',
            },
            // {
            //     field: 'cold_dt',
            //     render: (record) => {
            //         return record.colldetails ? record.colldetails.cold_dt : null;
            //     },
            //     caption: 'Date'
            // },
            // {
            //     field: 'Collected By',
            //     render: (record) => {
            //         return record.colldetails ? record.colldetails.cold_user : null;
            //     },
            //     caption: 'cold_user'
            // },
            {
                field: 'opb_remarks',
                render: record => {
                    return record.opb_remarks;
                },
                caption: 'Remarks',
            },
        ];
    }

    getCustomers = cc_mode => {
        return ApiUtils.get({
            url: `customer?cc_mode=${cc_mode}`,
        });
    };

    checkCode = (code, mode) => {
        return ApiUtils.get({
            url: `settingslist/table-data?table_name=customer&primary_key=cc_code&composite_key=cc_mode&primary_key_value=${code}&composite_key_value=${mode}`,
            headers: {
                db_ptr: 'nuraho'
            }

        });
    };

    getCustomerWithId = code => {
        return ApiUtils.get({
            url: `customer/${code}`,
        });
    };

    /**
    * Edit customer details
    * @param {*} code
    * @returns
    */
    //  editCustomer = (code, values) => {
    //     var formBody = {
    //         ...values,
    //     };
    //     return ApiUtils.put({ url: `customer/${code}`, formBody });
    // };

    addCustomer = values => {
        var formBody = {
            ...values,
        };
        return ApiUtils.post({
            url: 'customer/create-customer', formBody,
            headers: {
                Authorization: 'Bearer' + ' ' + localStorage.access_token,
                db_ptr: 'nuraho',
            },
        });
    };

    /**
     * Edit customer details
     * @param {*} code 
     * @param {*} formBody 
     * @returns 
     */
    editCustomer = (code, formBody) => {
        return ApiUtils.put({
            url: `customer/update-customer/${code}`,
            formBody,
            headers: {
                Authorization: 'Bearer' + ' ' + localStorage.access_token,
                db_ptr: 'nuraho',
            },
        });
    };

    Card = ({ ...props }) => {
        return <GuestCard record={props} {...props}></GuestCard>;
    };

    // DetailComponent = (routeParams) => <BillDetailView {...routeParams} model={this} />;
    //  AddComponent = () => <CollectionAdd model={this} />;
}

function GuestCard({ record }) {
    return (
        <Card className="card vehicle-card">
            <div className="card">
                <h2 className="title">{record.opb_name}</h2>

                {/* {record.preReg.opb_age} */}

                {/* <h3 className="values">{record.da_aptime}</h3> */}

                {/* <Tag color={record.da_questfilled === 'F' ? 'orange' : 'green'}>{record.da_questfilled === 'F' ? 'Filled' : 'Pending'}</Tag> */}

                <Tag color="green">{record.opb_gender}</Tag>

                <Text type="secondary">{record.opb_mobile}</Text>

                <h4 className="values">{record.opb_opno}</h4>
            </div>
        </Card>
    );
}

export default Customer;
